export enum rolePermissionTypes {
    ROLE_DATA = 'ROLE_DATA',
    ROLE_PERMISSION_DATA = 'ROLE_PERMISSION_DATA',
    USER_DATA = 'USER_DATA',
    USER_PERMISSION_DATA = 'USER_PERMISSION_DATA',
    USER_PERMISSION_LOADING = 'USER_PERMISSION_LOADING',
    USER_PERMISSION_LOADED = 'USER_PERMISSION_LOADED'
}